import { useEffect, useRef } from 'react'
import css from '../Landing.module.css'

/**
 * Hook that returns a ref to attach to an element for fade-up on scroll.
 * Toggles the fadeUpVisible CSS module class when element enters viewport.
 */
export function useFadeUp<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            el.classList.add(css.fadeUpVisible)
            observer.unobserve(el)
          }
        })
      },
      { threshold: 0, rootMargin: '0px 0px 60px 0px' },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return ref
}
